var OrderService = (function () {

    'use strict';


    var itemsInBasket = [];
    var totalPriceInBasket = 0.0;
    var promoItemsIds = {};
    var isShown = false;
    var xhrCheckOrder = null;

    let deliveryAlertOldText = "";

    var alertStack = {
        isOpen: false,
        index:0,
        stack:[]
    };

    function addAndShow(alert){
        alertStack.stack.push(alert);
        showNextAlert();
    }

    function showNextAlert(){
        let isNotOpen = !alertStack.isOpen;
        let nextExist = alertStack.index !== alertStack.stack.length;

        if(isNotOpen && nextExist){
            alertStack.isOpen = true;
            $("#" + alertStack.stack[alertStack.index]).modal('show');
            ++ alertStack.index;
        }
    }

    function closeAlert(){
        let last = alertStack.index -1;

        $("#" + alertStack.stack[last]).modal('hide');
        alertStack.isOpen = false;

        showNextAlert();
    }

    function checkCityOrderBlock(){
        var cityId = $('.js-current-cityId').val();
        var blockStatusUrl = 'api/v1/city/' + cityId + '/block-status';
        $.ajax({
            url: blockStatusUrl,
            type: 'GET',
            data: {},
            contentType: 'application/json',
            success: function (response) {
                var blockStatus = response.result;
                switch(blockStatus.status){
                    case 'BLOCK':  setBlock(); break;
                    case 'WARNING':  setWarning(); break;
                }
            },
            error: function () {}
         })
    }

    function setBlock(){
        $('.js-create-order-button').prop( "disabled", true );
        $('.js-create-order-button').css("background-color", "rgb(170, 170, 170)");
        addAndShow("modalCityBlockOrderModal");

    }

    function setWarning(){
        addAndShow("modalCityBlockOrderModal");
    }


    function getBasketSession(date, time, payment, shopId, orderType, address) {
        $.get('/getBasket', function (response) {
            if (response.code === '200') {
                totalPriceInBasket = response.result.totalPrice;
                itemsInBasket = [];
                promoItemsIds = response.result.promoItemsIds;
                $.each(response.result.items, function (index, item) {
                    var itemInBasket = {
                        id: item.id,
                        itemId: item.itemId,
                        count: item.count,
                        isWok: item.wok,
                        composites: [],
                        selectedAddons: item.selectedAddons
                    };
                    if (item.composites.length !== 0) {
                        $.each(item.composites, function (index, composite) {
                            var compositeItem = {
                                id: composite.id,
                                itemId: composite.itemId,
                                count: composite.count
                            };
                            itemInBasket.composites.push(compositeItem);
                        })
                    }
                    // добавляем айтем из корзины
                    itemsInBasket.push(itemInBasket);
                });
                if (itemsInBasket.length !== 0) {
                    checkOrder(date, time, payment, shopId, orderType, address);
                }
            }
        })
    }

    function initializeLoyaltyProgramSlider(response, userPoints) {
        let basketPrice = response.result.orderResponse.totalPrice / 100;

        //нижняя граница слайдера
        let deliveryPointsLowerBound = $('.js-courier-loyalty-eggs-lower-bound');
        let pickupPointsLowerBound = $('.js-pickup-loyalty-eggs-lower-bound');

        //верхняя граница слайдера
        let deliveryPointsUpperBound = $('.js-courier-loyalty-eggs-upper-bound');
        let pickupPointsUpperBound = $('.js-pickup-loyalty-eggs-upper-bound');

        // элемент input[range]
        let deliveryInputRange = $('.js-courier-loyalty-points');
        let pickupInputRange = $('.js-pickup-loyalty-points');

        // элемент input[range] mobile
        let deliveryPointsMobile = $('.js-courier-loyalty-points-mobile');
        let pickupPointsMobile = $('.js-pickup-loyalty-points-mobile');

        // цена на кнопке, при оформлении заказа
        let finalPriceCourier = $('.js-courier-final-price');
        let finalPricePickup = $('.js-pickup-final-price');

        finalPriceCourier.text(basketPrice);
        finalPriceCourier.attr('data-courier-price', basketPrice);
        finalPricePickup.text(basketPrice);
        finalPricePickup.attr('data-pickup-price', basketPrice);

        $('.js-courier-final-price').data('courier-price', basketPrice);
        $('.js-pickup-final-price').data('pickup-price', basketPrice);

        deliveryInputRange.val(0);
        pickupInputRange.val(0);

        deliveryPointsLowerBound.val(0);
        pickupPointsLowerBound.val(0);

        if (basketPrice < userPoints) {
            //доставка
            deliveryPointsUpperBound.attr('data-max-eggs-courier', basketPrice);
            deliveryPointsUpperBound.text(basketPrice);
            deliveryPointsMobile.attr('placeholder', basketPrice);
            deliveryPointsMobile.attr('maxlength', basketPrice);
            deliveryInputRange.attr('max', basketPrice);

            //самовывоз
            pickupPointsUpperBound.attr('data-max-eggs-pickup', basketPrice);
            pickupPointsUpperBound.text(basketPrice);
            pickupPointsMobile.attr('placeholder', basketPrice);
            pickupPointsMobile.attr('maxlength', basketPrice);
            pickupInputRange.attr('max', basketPrice);
        } else {
            //доставка
            deliveryPointsUpperBound.attr('data-max-eggs-courier', userPoints);
            deliveryPointsUpperBound.text(userPoints);
            deliveryPointsMobile.attr('placeholder', userPoints);
            deliveryPointsMobile.attr('maxlength', userPoints);
            deliveryInputRange.attr('max', userPoints);

            //самовывоз
            pickupPointsUpperBound.attr('data-max-eggs-pickup', userPoints);
            pickupPointsUpperBound.text(userPoints);
            pickupPointsMobile.attr('placeholder', userPoints);
            pickupPointsMobile.attr('maxlength', userPoints);
            pickupInputRange.attr('max', userPoints);
        }
    }

    function initializeCountOfPointsForCurrentOrder(response) {
        $('.js-courier-points-for-order').text(response);
        $('.js-courier-points-for-order-mobile').text(response);
        $('.js-pickup-points-for-order').text(response);
        $('.js-pickup-points-for-order-mobile').text(response);
    }

    function checkOrder(date, time, paymentType, shopId, orderType, address) {
        var coupon = $('.js-cart-item-coupon') === undefined ? '' : $('.js-cart-item-coupon').val();
        var cityId = $('.js-current-cityId').val();
        var oType = orderType? orderType : ($('.js-courier-selection').is(':visible') === true ? 'DELIVERY' : 'OWN');
        var info = {
            name: '',
            phone: '',
            comment: '',
            isRecall: null,
            dateTo: date,
            timeTo: time,
            cashBack: '',
            methodOfConfirmation: null,
            payment: paymentType === 'NOT_PAYED' ? null : paymentType,
            type: oType,
            shopId: shopId === 'Выберите СушиВёсла' ? null : shopId,
            deliveryAddress: address
        };
        var deviceInfo = {
            type: 'WEB',
            deviceType: '',
            device: '',
            version: '',
            system: '',
            token: ''
        };
        var data = {
            items: itemsInBasket,
            totalPrice: totalPriceInBasket,
            coupon: coupon,
            cityId: cityId,
            info: info,
            deviceInfo: deviceInfo,
            promoItemsIds: promoItemsIds
        };

        //думаю я должен обьясниться. Эти сбрасывания запроса реализованы для того чтоб медленый запрос который тормозит не перетирал последний
        if(xhrCheckOrder != null){
            xhrCheckOrder.abort();
        }

        xhrCheckOrder = $.ajax({
            url: '/api/v4/order/checkOrder',
            type: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json',
            success: function (response) {
                var bonusPointFromOrder = response.result.orderResponse.bonusPointsForOrder;
                var isDoubleCashBackActive = false;

                $('.js-cart-price').text(response.result.orderResponse.totalPrice / 100);
                $('.js-cart-price').attr('data-original-price', response.result.orderResponse.originalPrice / 100);


                if(response.result.orderResponse.leftUntilDelivery == 0){
                    if(deliveryAlertOldText)
                        deliveryAlertOldText = $(".js-check-price-body").text();
                    $(".js-check-price-body").html("Доставка в выбранной зоне временно недоступна 😞 <br> Приносим извинения за неудобства!");
                }else{
                    if(deliveryAlertOldText)
                        $(".js-check-price-body").text(deliveryAlertOldText);
                }

                CartService.externalUpdateDeliveryStatus(response.result.orderResponse.deliveryAvailable);

                $('.js-delivery-cost').text(response.result.orderResponse.deliveryOriginalCost / 100);
                if(response.result.orderResponse.leftUntilFreeDelivery > 0){
                    $('.js-left-until-free-delivery-block').show();
                    $('.js-left-until-free-delivery-value').text(response.result.orderResponse.leftUntilFreeDelivery / 100);
                }else{
                    $('.js-left-until-free-delivery-block').hide();
                }

                if (response.result.promotionsInOrderResponse.promotionsInOrder.length !== 0) {
                    $('.js-cart-all-promotion').show();
                    var sum = '';
                    var promotionElement = $('.js-cart-promotion-item');
                    $.each(response.result.promotionsInOrderResponse.promotionsInOrder, function (index, promotion) {
                        if (promotion.type === 'DISCOUNT_COUPON' && promotion.price === 0 && promotion.items.length === 0) { // поле вводка купона, условие на выдачу ошибки по купону
                            var element = $('.js-cart-coupon');
                            element.show();
                            element.find('.js-cart-coupon-image').attr('src', '/pics/' + promotion.picture);
                            element.find('.js-cart-coupon-title').text(promotion.title);
                            element.find('.js-cart-item-coupon-form').show();
                            element.find('.js-cart-item-coupon-description').hide();
                            element.find('.js-cart-item-total-price').hide();
                            element.find('.js-cart-item-amount-price').hide();
                            element.find('.js-cart-coupon-delete').hide();
                            element.find('.js-cart-item-coupon-change').hide();
                            validateCouponField($('.js-cart-item-coupon'));
                        } else if(promotion.type === 'DOUBLE_CASH_BACK'){
                            isDoubleCashBackActive = true;
                        }else if(promotion.type === 'REFERRAL_PROGRAM'){
                            var element = $('.js-cart-coupon');
                            element.show();
                            element.find('.js-cart-coupon-image').attr('src', '/pics/' + promotion.picture);
                            element.find('.js-cart-coupon-title').text(promotion.title);
                            element.find('.js-cart-item-coupon-form').hide();
                            element.find('.js-cart-item-amount-price').show();
                            element.find('.js-cart-item-total-price').show();
                            element.find('.js-cart-item-coupon-description').show();
                            element.find('.js-cart-item-coupon-description').text(promotion.description);
                            element.find('.js-cart-coupon-delete').show();
                            element.find('.js-cart-item-amount-price').hide();
                            removeHasErrorFields($('.js-cart-item-coupon'));

                        }else if ((promotion.type === 'DISCOUNT_COUPON' || promotion.type === 'IIKO_PROMOTION') && promotion.price < 0) {      // скидка
                            var element = $('.js-cart-coupon');
                            element.show();
                            element.find('.js-cart-coupon-image').attr('src', '/pics/' + promotion.picture);
                            element.find('.js-cart-coupon-title').text(promotion.title);
                            element.find('.js-cart-item-coupon-form').hide();
                            element.find('.js-cart-item-amount-price').show();
                            element.find('.js-cart-item-total-price').show();
                            element.find('.js-cart-item-coupon-description').show();
                            element.find('.js-cart-item-coupon-description').text(promotion.description);
                            element.find('.js-cart-coupon-delete').show();
                            element.find('.js-cart-item-total-price').text(promotion.price / 100);
                            removeHasErrorFields($('.js-cart-item-coupon'));
                        } else if ((promotion.type === 'DISCOUNT_COUPON' || promotion.type === 'IIKO_PROMOTION') && promotion.items.length === 1) { // сработал купон на товар
                            var element = $('.js-cart-coupon');
                            element.show();
                            $.each(promotion.items, function (index, item) {
                                element.find('.js-cart-coupon-image').attr('src', '/pics/' + item.picture);
                                element.find('.js-cart-coupon-title').text(item.title);
                                element.find('.js-cart-item-coupon-form').hide();
                                element.find('.js-cart-item-amount-price').show();
                                element.find('.js-cart-item-total-price').show();
                                element.find('.js-cart-item-total-price').text(0);
                                element.find('.js-cart-item-coupon-description').show();
                                if (coupon.length !== 0) {
                                    element.find('.js-cart-coupon-delete').show();
                                } else {
                                    element.find('.js-cart-coupon-delete').hide();
                                }
                                element.find('.js-cart-item-coupon-description').text(promotion.description);
                                removeHasErrorFields($('.js-cart-item-coupon'));
                            });
                        } else if ((promotion.type === 'DISCOUNT_COUPON' || promotion.type === 'IIKO_PROMOTION') && promotion.items.length > 1) {
                            var element = $('.js-cart-coupon');
                            element.show();
                            $.each(promotion.promoItemsIds, function (key, promoItemIds) {
                                if (promotion.id === key) {
                                    $.each(promoItemIds, function (index, id) {
                                        $.each(promotion.items, function (i, promoItem) {
                                            if (promoItem.id === id) {
                                                element.find('.js-cart-coupon-image').attr('src', '/pics/' + promoItem.picture);
                                                element.find('.js-cart-coupon-title').text(promotion.title);
                                                element.find('.js-cart-item-coupon-form').hide();
                                                element.find('.js-cart-item-amount-price').show();
                                                element.find('.js-cart-item-coupon-description').text(promoItem.title);
                                                if (coupon.length !== 0) {
                                                    element.find('.js-cart-coupon-delete').show();
                                                } else {
                                                    element.find('.js-cart-coupon-delete').hide();
                                                }
                                                element.find('.js-cart-item-coupon-change').show();
                                                element.find('.js-cart-item-coupon-change')
                                                    .attr('class', 'button mod-small mod-secondary mod-promo-item-change js-cart-item-coupon-change');
                                                element.find('.js-cart-item-coupon-change').attr("data-promo", promotion.id);
                                                element.find('.js-cart-item-total-price').show();
                                                element.find('.js-cart-item-total-price').text(0);
                                                element.find('.js-cart-item-coupon-description').show();
                                                removeHasErrorFields($('.js-cart-item-coupon'));
                                            }
                                        });
                                    });
                                }
                            })
                        } else if(promotion.type === 'SUBSCRIPTION' && promotion.price < 0) {
                            var element = $('.js-cart-subscription');
                            element.show();
                            element.find('.js-cart-subscription-image').attr('src', '/pics/' + promotion.picture);
                            element.find('.js-cart-subscription-title').text(promotion.title);
                            element.find('.js-cart-item-subscription-form').hide();
                            element.find('.js-cart-item-amount-price').show();
                            element.find('.js-cart-item-total-price').show();
                            element.find('.js-cart-item-subscription-description').show();
                            element.find('.js-cart-item-subscription-description').text(promotion.description);
                            element.find('.js-cart-subscription-delete').show();
                            element.find('.js-cart-item-total-price').text(promotion.price / 100);
                            removeHasErrorFields($('.js-cart-item-subscription'));
                        }else if (promotion.type !== 'EQUALS_THREE' && promotion.type !== 'BIRTHDAY_GIFT') { // любая акция кроме купона,дня рождения,1 + 1 = 3
                            promotionElement.show();

                            promotionElement.find('.js-cart-promotion-item-image').attr('src', '/pics/' + promotion.picture);
                            promotionElement.find('.js-cart-promotion-item-title').text(promotion.title);
                            promotionElement.find('.js-cart-promotion-item-description').text(promotion.description);
                            promotionElement.find('.js-cart-promotion-item-change').hide();

                            sum += promotionElement.html();
                        } else if (promotion.type === 'EQUALS_THREE' || promotion.type === 'BIRTHDAY_GIFT') {  // акция 1+1 = 3 или день рождение
                            $.each(promotion.promoItemsIds, function (key, value) {
                                if (promotion.id == key) {
                                    var pos = -1;
                                    $.each(value, function (index, id) {
                                        $.each(promotion.items, function (i, promoItem) {
                                            if (promoItem.id == id) {
                                                pos++;
                                                if (promotion.type === 'BIRTHDAY_GIFT') {
                                                    promotionElement.find('.js-cart-promotion-item-image').attr('src', '/pics/' + promoItem.picture);
                                                } else if (promotion.type === 'EQUALS_THREE') {
                                                    promotionElement.find('.js-cart-promotion-item-image').attr('src', '/pics/' + promoItem.picture);
                                                } else {
                                                    promotionElement.find('.js-cart-promotion-item-image').attr('src', '/pics/' + promotion.picture);
                                                }
                                                promotionElement.find('.js-cart-promotion-item-title').text(promoItem.title);
                                                promotionElement.find('.js-cart-promotion-item-description').text(promoItem.description);
                                                promotionElement.find('.js-cart-promotion-item-change').show();
                                                promotionElement.find('.js-cart-promotion-item-change')
                                                    .attr('class', 'button mod-small mod-secondary mod-promo-item-change js-cart-promotion-item-change');
                                                promotionElement.find('.js-cart-promotion-item-change').attr("data-pos", pos);
                                                promotionElement.find('.js-cart-promotion-item-change').attr("data-promo", promotion.id);
                                                sum += promotionElement.html();
                                            }
                                        });
                                    });
                                }
                            });
                        }
                        $('.js-cart-promotion-item').hide();
                        $('.js-cart-all-promotion').html(sum);
                    });
                } else {
                    $('.js-cart-coupon').hide();
                    $('.js-cart-all-promotion').hide();
                }

                if(isDoubleCashBackActive){
                    $('#modalCashBack').attr('promoActive', true);

                    if(oType == "OWN")
                        bonusPointFromOrder = bonusPointFromOrder * 2;
                }else{
                    $('#modalCashBack').attr('promoActive', false);
                }


                initializeCountOfPointsForCurrentOrder(bonusPointFromOrder);

                if (response.result.alertOrderResponse !== null && response.result.orderResponse.totalPrice === 0) {
                    $(".modal.in").modal('hide').on('hidden.bs.modal', functionThatEndsUpDestroyingTheDOM);
                    $('.js-cart-order-button').attr('disabled', 'disabled').addClass('disabled');
                    $('.js-check-price-title').text(response.result.orderAlertResponse.title);
                    $('.js-check-price-body').text(response.result.orderAlertResponse.body);
                    $('#checkPriceModal').modal('show');
                    addAndShow("checkPriceModal");
                }

                if ($('main.content').attr('data-general-tab') == 'basket') {
                    let userPoints = $('.js-loyalty-user-points').data('user-points');

                    if (userPoints !== undefined && userPoints > 0) {
                        initializeLoyaltyProgramSlider(response, userPoints);
                    } else {
                        initializeLoyaltyProgramSlider(response, 0);
                    }

                }

                if(response.result.orderResponse.showWishes)
                    $(".js-wishes-toggle").show();
                else
                    $(".js-wishes-toggle").hide();

                xhrCheckOrder = null;
            },
            error: function () {
                $('.js-cart-item-coupon').addClass('has-error');
                var couponInput = $('.js-cart-item-coupon');
                AppService.displayError("Промо-код не действителен", couponInput);
                $('.js-cart-item-coupon').val('');
            }
        })
    }

    function functionThatEndsUpDestroyingTheDOM() {
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    }

    function validateCouponField(element) {
        if (element.val() !== "") {
            element.addClass('has-error');
            var couponInput = element;
            AppService.displayError("Промо-код не действителен", couponInput);
            element.val("");
        }
    }

    function removeHasErrorFields(element) {
        if (element != null) {
            element.removeClass('has-error');
            var couponInput = element;
            AppService.deleteError(couponInput);
        }
    }

    function checkOrderOnBasketPage() {
        if ($('main.content').attr('data-general-tab') == 'basket') {
            getBasketSession(null, null, null, null, null, null);
        }
    }

    function checkOrderOnCouponApply() {
        $('.js-cart').on('click', '.js-apply-coupon', function () {
            getBasketSession(null, null, null, null, null, null);
        });
    }

    function resetCouponField() {
        $('.js-cart').on('click', '.js-cart-coupon-delete', function () {
            if ($('.js-cart-item-coupon') !== undefined) {
                $('.js-cart-item-coupon').val('');
                getBasketSession(null, null, null, null, null, null);
            }
        });
    }

    function checkChooseItemPayload(position) {
        var coupon = $('.js-cart-item-coupon') === undefined ? '' : $('.js-cart-item-coupon').val();
        var cityId = $('.js-current-cityId').val();
        var info = {
            name: '',
            phone: '',
            comment: '',
            isRecall: null,
            dateTo: '',
            timeTo: '',
            cashBack: '',
            methodOfConfirmation: null,
            payment: null,
            type: null,
            shopId: null,
            deliveryAddress: null
        };
        var deviceInfo = {
            type: 'WEB',
            deviceType: '',
            device: '',
            version: '',
            system: '',
            token: ''
        };
        // формируем запрос
        var data = {
            items: itemsInBasket,
            totalPrice: totalPriceInBasket,
            coupon: coupon,
            cityId: cityId,
            info: info,
            deviceInfo: deviceInfo,
            promoItemsIds: promoItemsIds
        };

        $.ajax({
            url: '/api/v4/order/checkOrder',
            type: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json',
            success: function (response) {
                $.each(response.result.promotionsInOrderResponse.promotionsInOrder, function (index, promotion) {
                    if ((promotion.type === 'DISCOUNT_COUPON' || promotion.type === 'IIKO_PROMOTION') && promotion.items.length !== 0) {
                        $('.js-cart-all-reward-items').show();
                        var sum = '';
                        var element = $('.js-cart-reward-item');

                        $.each(promotion.items, function (index, promotionItem) {

                            element.show();

                            element.find('.js-cart-reward-item-promo-id').attr('value', promotion.id);
                            element.find('.js-cart-reward-item-item-id').attr('value', promotionItem.id);
                            element.find('.js-cart-reward-item-image').attr('style', 'background-image: url(/pics/'
                                + promotionItem.picture + '); background-size: cover; background-position: center;');
                            element.find('.js-cart-reward-item-title').text(promotionItem.title);

                            sum += element.html();
                        });
                        $('.js-cart-reward-item').hide();
                        $('.js-cart-all-reward-items').html(sum);
                        $('#position').attr('value', position);
                        $('#modalChangePromoItem').modal('show');
                    }
                })
            },
            error: function () {
            }
        })
    }

    function bannerOnCloseListener(){
        var checkPriceModal = $(".js-checkPriceModal-close");
        var modalCityBlockOrderModal = $(".js-modalCityBlockOrderModal-close");
        modalCityBlockOrderModal.click(function(){
            closeAlert();
        });

        checkPriceModal.click(function(){
            closeAlert();
        });
    }


    function init() {
        $('#discountPurchaseAlert').on('hidden.bs.modal', function (e) {
            $(document.body).addClass('modal-open');
        });

        checkCityOrderBlock();
        bannerOnCloseListener();

        $('.js-cart-order-button').click(function () {
            getBasketSession(null, null, null, null, null, null)
        });
        resetCouponField();
        checkOrderOnBasketPage();
        checkOrderOnCouponApply();
    }

//************ Public ************//
    return {
        init: init,
        checkChooseItemPayload: checkChooseItemPayload,
        getBasketSession: getBasketSession,
        addAndShow: addAndShow
    };
})
();

$(OrderService.init);